import { IInteractionsCount } from "@edgetier/watchtower-types";

/**
 * Compute phrase trigger total count across all days
 * @param queryData
 */
export const getPhraseTriggerCountData = (queryData: IInteractionsCount<any>[] | undefined) => {
    const totalCountAcrossAllDays: Record<string, number> = (queryData ?? []).reduce((previousData, currentEntry) => {
        return {
            ...previousData,
            [currentEntry.group[1]]: (previousData[currentEntry.group[1]] ?? 0) + currentEntry.count,
        };
    }, {} as Record<string, number>);

    return totalCountAcrossAllDays;
};
